/* eslint-disable react/prop-types */
import React from "react";
import { Link } from "react-router-dom";
import { useDemoScrollToTop } from "../../hooks/useDemoScrollToTop";
import { Alert, Button, Divider, Layout, Row, Typography } from "antd";
import Submit from "../../components/submit";
import Sales from "../dashboard/sales";
import DemoFilmCard from "./DemoFilmCard";
import DemoLayout from "./DemoLayout";
import DemoPayoutsTable from "./DemoPayoutsTable";
import {
  DUMMY_REVENUE,
  DUMMY_LIVE_PROJECTS,
  DUMMY_ELIGIBLE_PROJECTS,
  DUMMY_PAYOUT_ROWS,
} from "./dummyData";

const { Content } = Layout;
const { Title, Text } = Typography;

/**
 * Public preview of the distribution dashboard using fictional data only.
 * Lead capture (Submit) writes to Firestore collection black-leads when used.
 */
const DemoDashboard = () => {
  useDemoScrollToTop([]);

  return (
    <DemoLayout>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <Alert
          showIcon
          type="info"
          message="Sample dashboard"
          description="Numbers, projects, and payouts below are fictional and for illustration only. Sign in with your SHORTED account to see your real distribution data. Open a live sample project to see analytics charts."
          style={{ marginTop: 24, marginBottom: 16 }}
        />

        <Layout style={{ minHeight: "auto" }}>
          <Content className="site-layout-background" style={{ marginTop: 8 }}>
            <Row>
              <Submit />
              <Divider />
              <Layout>
                <Row>
                  <Title level={4}>Live Projects</Title>
                </Row>
                <Row>
                  {DUMMY_LIVE_PROJECTS.map((item) => (
                    <DemoFilmCard key={item.uid} item={item} />
                  ))}
                </Row>
              </Layout>
              <Divider />
              <Layout>
                <Row>
                  <Title level={4}>Eligible Projects</Title>
                </Row>
                <Row>
                  {DUMMY_ELIGIBLE_PROJECTS.map((item) => (
                    <DemoFilmCard key={item.uid} item={item} />
                  ))}
                </Row>
              </Layout>
            </Row>

            <Sales revenue={DUMMY_REVENUE} />
            <Divider />
            <DemoPayoutsTable rows={DUMMY_PAYOUT_ROWS} />

            <div style={{ marginTop: 24, textAlign: "center" }}>
              <Text
                type="secondary"
                style={{ display: "block", marginBottom: 12 }}
              >
                Ready to track your own releases?
              </Text>
              <Link to={{ pathname: "/", hash: "login" }}>
                <Button type="primary" size="large">
                  Sign in to your dashboard
                </Button>
              </Link>
            </div>
          </Content>
        </Layout>
      </div>
    </DemoLayout>
  );
};

export default DemoDashboard;
